/**
 * @module components\ghMenu
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class GhMenu extends Vue {
  @Prop({ default: 200 })
  private nudgeWidth!: number;
  @Prop({ default: false })
  private closeOnConentClick!: boolean;

  @Prop({ default: false })
  private closeOnClick!: boolean;

  @Prop({ default: false })
  private allowSubmit!: boolean;
  @Prop({ default: "" })
  private btnText!: string;
  @Prop({ default: true })
  private showActions!: boolean;

  @Prop()
  private title!: string;

  private menu = false;

  private submit() {
    this.menu = false;
    this.$emit("submit");
    // this.$validator.verify(value,"required")
    // this.$validator.validate("required",value)
  }
  public close() {
    this.menu = false;
  }
}
